import * as React from 'react';
import { AppNavigation } from './screens';
import { Header } from 'components';
import { ThemeProvider } from '@emotion/react';
import { theme } from './theme';
import { Footer } from 'components';
import { Modals } from 'components';
import { SnackbarProvider } from 'notistack';
import { useSilentLogin } from 'hooks/useSilentLogin';

export const App = () => {
  useSilentLogin();

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          classes={{ containerRoot: 'notifications__root' }}
          disableWindowBlurListener
          dense
        >
          <Header />
          <AppNavigation />
          <Footer />
          <Modals />
        </SnackbarProvider>
      </div>
    </ThemeProvider>
  );
};

export default App;
